import React, {useEffect, useState} from "react";
import {useDispatch, useSelector} from "react-redux";
import {logout} from "../../Actions/loginAction";
import {BILLING_COMPONENT} from "../Billing/billingPageWrapper";
import {DASHBOARD_COMPONENT} from "../Dashboard/dashboardWrapper";
import {constructSelectedComponent} from "../../Factory/factory"
import {EARNING_COMPONENT} from "../Earning/earningPageWrapper";
import {PROFILE_COMPONENT} from "../Profile/profilePageWrapper";
import {PAYMENT_COMPONENT} from "../Payments/paymentsWrapper";
import {PAYOUTS_COMPONENT} from "../Payouts/payoutsWrapper";
import {PARTNER_CODE_AND_LINK_COMPONENT} from "../partnerCodeAndLinks/partnerCodeAndLinksWrapper";
import {USAGE_COMPONENT} from "../Usage/usageWrapper";

const LEFT_SIDE_BAR = "LEFT_SIDE_BAR";
const LEFT_SIDE_BAR_SELECTED = "LEFT_SIDE_BAR_SELECTED";
const PARTNER_TYPE_AFFILIATE = "AFFILIATE";
const PARTNER_TYPE_RESELLER = "RESELLER";

const LeftNavbar = () => {
    const sideBarActive = useSelector(state => state.leftSideBarActive);
    const partnerDetails = useSelector(state => state.partnerDetails);
    const globalSelectedComponent = useSelector(state => state.selectedComponent);
    const [selectedComponent, setSelectedComponent] = useState(DASHBOARD_COMPONENT);
    const dispatch = useDispatch();
    const closeNavBar = () => {
        dispatch({
            type: LEFT_SIDE_BAR,
            payload: false
        })
    }

    const setActiveComponent = (component) => {
        setSelectedComponent(component);
        dispatch({
            type: LEFT_SIDE_BAR_SELECTED,
            payload: constructSelectedComponent(component)
        })
    }

    const showEarning = () => {
        if (partnerDetails.partnerType === PARTNER_TYPE_AFFILIATE) return true;
        else return false;
    }

    useEffect(() => {
        if (globalSelectedComponent !== null && globalSelectedComponent?.component !== selectedComponent) {
            setSelectedComponent(globalSelectedComponent.component);
        }
    }, [globalSelectedComponent?.component])

    if (partnerDetails === null) return <></>

    return (
        <div
            className={`side-navbar d-flex justify-content-between flex-wrap flex-column ${sideBarActive ? "activeNav" : ""}`}>
            <ul className="nav list-group flex-column w-100">
                {/*<div className="text-end px-2 fs-3 closeNavBar" role="button" onClick={closeNavBar}><i*/}
                {/*    className="bi bi-x"></i></div>*/}
                {/*<div className="partner-welcome px-3 pt-5 pb-3">*/}
                {/*    {partnerDetails.companyName}*/}
                {/*</div>*/}
                {/*<div className="ps-3 pe-2 pt-0 pb-3 text-break w-100 text-truncate">*/}
                {/*    {partnerDetails.email}*/}
                {/*</div>*/}
                <li className={`nav-link ${selectedComponent === DASHBOARD_COMPONENT ? "nav-selected" : ""}`}
                    onClick={() => {
                        setActiveComponent(DASHBOARD_COMPONENT)
                    }}>
                    <i className="bi bi-view-stacked"></i><span className="mx-2">Accounts</span>
                </li>
                {!showEarning() &&
                <li className={`nav-link ${selectedComponent === BILLING_COMPONENT ? "nav-selected" : ""}`}
                    onClick={() => {
                        setActiveComponent(BILLING_COMPONENT)
                    }}>
                    <i className="bi bi-receipt"></i><span className="mx-2">Billing</span>
                </li>
                }
                {showEarning() &&
                <li className={`nav-link ${selectedComponent === EARNING_COMPONENT ? "nav-selected" : ""}`}
                    onClick={() => {
                        setActiveComponent(EARNING_COMPONENT)
                    }}>
                    <i className="bi bi-receipt"></i><span className="mx-2">Earnings</span>
                </li>}
                <li className={`nav-link ${selectedComponent === USAGE_COMPONENT ? "nav-selected" : ""}`}
                    onClick={() => {
                        setActiveComponent(USAGE_COMPONENT)
                    }}>
                    <i className="bi bi-clipboard-data"></i><span className="mx-2">Usage</span>
                </li>
                {!showEarning() &&
                <li className={`nav-link ${selectedComponent === PAYMENT_COMPONENT ? "nav-selected" : ""}`}
                    onClick={() => {
                        setActiveComponent(PAYMENT_COMPONENT)
                    }}>
                    <i className="bi bi-credit-card"></i><span className="mx-2">Payments</span>
                </li>
                }
                {showEarning() &&
                <li className={`nav-link ${selectedComponent === PAYOUTS_COMPONENT ? "nav-selected" : ""}`}
                    onClick={() => {
                        setActiveComponent(PAYOUTS_COMPONENT)
                    }}>
                    <i className="bi bi-wallet2"></i><span className="mx-2">Payouts</span>
                </li>}
                <li className={`nav-link ${selectedComponent === PARTNER_CODE_AND_LINK_COMPONENT ? "nav-selected" : ""}`}
                    onClick={() => {
                        setActiveComponent(PARTNER_CODE_AND_LINK_COMPONENT)
                    }}>
                    <i className="bi bi-link-45deg"></i><span className="mx-2">Partner Code and Links</span>
                </li>
                <li className={`nav-link ${selectedComponent === PROFILE_COMPONENT ? "nav-selected" : ""}`}
                    onClick={() => {
                        setActiveComponent(PROFILE_COMPONENT)
                    }}>
                    <i className="bi bi-person"></i><span className="mx-2">Profile</span>
                </li>
                <li className="nav-link" onClick={() => dispatch(logout())}>
                    <i className="bi bi-box-arrow-right"></i><span className="mx-2">Logout</span>
                </li>
            </ul>
        </div>
    )
}

export default LeftNavbar;
export {LEFT_SIDE_BAR, LEFT_SIDE_BAR_SELECTED, PARTNER_TYPE_AFFILIATE, PARTNER_TYPE_RESELLER};
